'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
// special cases for external & mail links from RTE
const anchors = Array.from(document.querySelectorAll('a'));
if (anchors) {
    anchors.map((item) => {
        if (!item.hasAttribute('data-track-event') &&
            !item.hasAttribute('data-trigger-gtm-event') &&
            item.hasAttribute('href') &&
            item.getAttribute('href').indexOf('return_url') === -1) {
            // Track download links
            if (item.getAttribute('href').startsWith('/fileadmin')) {
                let trackObject = item.getAttribute('title') || item.innerText;
                item.setAttribute('data-track-event', 'true');
                item.setAttribute('data-track-object', trackObject);
                item.setAttribute('data-track-action', 'Download');
                item.setAttribute('data-track-tags', '');
                item.setAttribute('data-track-value', '');
            }
            // Track mail links
            if (item.getAttribute('href').indexOf('linkTo_UnCryptMailto') > -1) {
                let trackObject = item.innerText;
                item.setAttribute('data-track-event', 'true');
                item.setAttribute('data-track-category', 'Kontakt');
                item.setAttribute('data-track-object', trackObject);
                item.setAttribute('data-track-action', 'Klick');
                item.setAttribute('data-track-tags', 'Klick auf Mailadresse');
                item.setAttribute('data-track-value', '');
            }
            // Track buttons
            if (item.classList.contains('btn')) {
                let trackObject = item.innerText;
                if (item.closest('div[id]')) {
                    let parentId = item.closest('div[id]').getAttribute('id');
                    item.setAttribute('data-track-event', 'true');
                    item.setAttribute('data-track-object', trackObject);
                    item.setAttribute('data-track-action', 'klick');
                    item.setAttribute('data-track-tags', '');
                    item.setAttribute('data-track-value', '');
                    item.setAttribute('data-gtm-event', 'event');
                    item.setAttribute('data-gtm-event-wrapper', 'true');
                    item.setAttribute('data-gtm-event-category', 'Button');
                    item.setAttribute('data-gtm-event-action', 'click');
                    item.setAttribute('data-gtm-event-label', trackObject + '_' + parentId);
                    item.setAttribute('data-trigger-gtm-event', 'event');
                    item.setAttribute('data-trigger-gtm-event-wrapper', 'true');
                    item.setAttribute('data-trigger-gtm-event-category', 'Button');
                    item.setAttribute('data-trigger-gtm-event-action', 'click');
                    item.setAttribute('data-trigger-gtm-event-label', trackObject + '_' + parentId);
                }
            }
            // Track external links
            if (item.getAttribute('href').indexOf('http://') > -1 ||
                item.getAttribute('href').indexOf('https://') > -1) {
                let trackObject = item.getAttribute('title') || item.innerText;
                item.setAttribute('data-track-event', 'true');
                item.setAttribute('data-track-object', trackObject);
                item.setAttribute('data-track-action', 'Externer Link');
                item.setAttribute('data-track-tags', '');
                item.setAttribute('data-track-value', '');
            }
        }
    });
}
// Track quick access area
const quickAccessPoints = Array.from(document.querySelectorAll('.cloud'));
if (quickAccessPoints) {
    quickAccessPoints.forEach((item) => {
        const trackObject = item.getAttribute('data-track-object');
        item.setAttribute('data-track-event', 'true');
        item.setAttribute('data-track-object', trackObject);
        item.setAttribute('data-track-action', 'Klick');
        item.setAttribute('data-track-category', 'Schnelleinstieg');
    });
}
// Track social media links in footer
const socialLinks = Array.from(document.querySelectorAll('.socials'));
if (socialLinks) {
    socialLinks.forEach((item) => {
        const trackObject = item.getAttribute('data-track-object');
        item.setAttribute('data-track-event', 'true');
        item.setAttribute('data-track-object', trackObject);
        item.setAttribute('data-track-action', 'Klick');
    });
}
// Track search (global and in FAQ)
const siteSearch = document.querySelector('#tx-solr-search-form-pi-results');
const faqSearch = document.querySelector('#faq_search');
const searchInput = document.querySelector('.tx-solr-q');
const searchButton = document.querySelector('.tx-solr-submit');
const trackSearch = (searchForm) => {
    searchForm.addEventListener('submit', (event) => {
        const trackObject = searchButton.getAttribute('data-track-object');
        const trackAction = searchInput.value;
        searchButton.setAttribute('data-track-event', 'true');
        searchButton.setAttribute('data-track-object', trackObject);
        searchButton.setAttribute('data-track-action', trackAction);
    });
};
if (siteSearch) {
    trackSearch(siteSearch);
}
if (faqSearch) {
    trackSearch(faqSearch);
}
// Track videos
const videoElements = Array.from(document.querySelectorAll('[data-youtube-url],[data-gs1-videoteaser]'));
if (videoElements) {
    videoElements.map((item) => {
        let trackObject = '';
        let titleElement = item.querySelector('.videplayer__description-title');
        if (titleElement) {
            trackObject = titleElement.innerText;
        }
        item.setAttribute('data-track-event', 'true');
        item.setAttribute('data-track-object', trackObject);
        item.setAttribute('data-track-action', 'Klick auf Video');
        item.setAttribute('data-track-category', 'Video');
    });
}
exports.default = {};
